import { define } from '../../define.js';
import { Badge } from './badge.js';
export * from './badge.js';
define('badge', Badge);
